import { useRpc } from "../core/useRpc.js";
export function useFilters({
  params,
  options,
  key: _key
} = {}, key) {
  return useRpc(
    "getFilters",
    _key ?? key ?? "useFilters",
    params,
    options
  );
}
